import util from './utils'

export default function mixins(Vue) {
  Vue.mixin({
    methods: {
      trackView(eventId, pageParam, param) {
        const { PAGE_ID } = this.$options
        const EVENT_ID = eventId || this.$options.EVENT_ID
        if (PAGE_ID) {
          if (EVENT_ID) {
            window.track &&
              window.track._launch({
                pageLevelId: PAGE_ID,
                logType: 10000,
                clickId: EVENT_ID,
                positionParam:
                  param !== undefined
                    ? JSON.stringify({ infotitle: param })
                    : undefined,
                pageParam: pageParam || undefined
              })
          } else {
            window.track &&
              window.track._launch({
                pageLevelId: PAGE_ID,
                logType: 10000,
                positionParam:
                  param !== undefined
                    ? JSON.stringify({ infotitle: param })
                    : undefined,
                pageParam: pageParam || undefined
              })
          }
        }
      },
      trackClick(eventId, param, pageParam, pageId, positionId) {
        const PAGE_ID = pageId || this.$options.PAGE_ID
        const EVENT_ID = eventId || this.$options.EVENT_ID
        if (PAGE_ID && EVENT_ID) {
          window.track &&
            window.track._launch({
              pageLevelId: PAGE_ID,
              positionParam:
                param !== undefined
                  ? typeof param === 'string' || 'number'
                    ? JSON.stringify({ infotitle: param })
                    : param
                  : undefined,
              logType: 20000,
              clickId: EVENT_ID,
              pageParam: pageParam || undefined,
              positionId
            })
        }
      },
      newTrackClick(eventId, param, pageParam, pageId, positionId) {
        const PAGE_ID = pageId || this.$options.PAGE_ID
        const EVENT_ID = eventId || this.$options.EVENT_ID
        if (PAGE_ID && EVENT_ID) {
          window.track &&
            window.track._launch({
              pageLevelId: PAGE_ID,
              positionParam:
                param !== undefined ? JSON.stringify(param) : undefined,
              logType: 20000,
              clickId: EVENT_ID,
              pageParam: pageParam || undefined,
              positionId
            })
        }
      },
      trackBT(param1, param2) {
        return util.trackerBT(param1, param2)
      }
    }
  })
}
